export const Marketing = [
  {
    label: "Content Marketers",
    key: "0",
  },
  {
    label: "Content Writers",
    key: "1",
  },
  {
    label: "Product Marketers",
    key: "2",
  },
  {
    label: "Digital Marketers",
    key: "3",
  },
  {
    label: "Growth Marketers",
    key: "4",
  },
  {
    label: "Marketers Executive",
    key: "5",
  },
  {
    label: "Social Media Managers",
    key: "6",
  },
  {
    label: "Email Managers",
    key: "7",
  },
  {
    label: "Lead Gen Specialist",
    key: "8",
  },
  {
    label: "Sales Representative",
    key: "9",
  },
];

export const Support = [
  {
    label: "Customer Support Managers",
    key: "1",
  },
  {
    label: "Customer Support",
    key: "2",
  },
  {
    label: "Customer Success Manager",
    key: "3",
  },
  {
    label: "Virtual Assistants",
    key: "4",
  },
];

export const Design = [
  {
    label: "Brand Identity Designers",
    key: "1",
  },
  {
    label: "Graphic Designers",
    key: "2",
  },
];

export const Finance = [
  {
    label: "Bookkeepers",
    key: "1",
  },
  {
    label: "Payroll Administrator",
    key: "2",
  },
  {
    label: "Finance Officer",
    key: "3",
  },
  {
    label: "Accountant",
    key: "4",
  },
];

export const HumanManagement = [
  {
    label: "Head of people & culture",
    key: "1",
  },
  {
    label: "Head of operation",
    key: "2",
  },
  {
    label: "HR",
    key: "3",
  },
  {
    label: "Head of talent",
    key: "4",
  },
];

export const experience = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const allTalent = [
  { value: "Content Marketers", label: "Content Marketers" },
  { value: "Content Writers", label: "Content Writers" },
  { value: "Product Marketers", label: "Product Marketers" },
  { value: "Digital Marketers", label: "Digital Marketers" },
  { value: "Growth Marketers", label: "Growth Marketers" },
  { value: "Marketers Executive", label: "Marketers Executive" },
  { value: "Social Media Managers", label: "Social Media Managers" },
  { value: "Email Managers", label: "Email Managers" },
  { value: "Lead Gen Specialist", label: "Lead Gen Specialist" },
  { value: "Sales Representative", label: "Sales Representative" },
  { value: "Customer Support Managers", label: "Customer Support Managers" },
  { value: "Customer Support", label: "Customer Support" },
  { value: "Customer Success Manager", label: "Customer Success Manager" },
  { value: "Virtual Assistants", label: "Virtual Assistants" },
  { value: "Brand Identity Designers", label: "Brand Identity Designers" },
  { value: "Graphic Designers", label: "Graphic Designers" },
  { value: "Bookkeepers", label: "Bookkeepers" },
  { value: "Payroll Administrator", label: "Payroll Administrator" },
  { value: "Finance Officer", label: "Finance Officer" },
  { value: "Head of people & culture", label: "Head of people & culture" },
  { value: "Head of operation", label: "Head of operation" },
  { value: "HR", label: "HR" },
  { value: "Head of talent", label: "Head of talent" },
];

export const socialDiscover = [
  {
    value: "LinkedIn",
    label: "LinkedIn",
  },
  {
    value: "Twitter",
    label: "Twitter",
  },
  {
    value: "Instagram",
    label: "Instagram",
  },
  {
    value: "Others",
    label: "Others",
  },
];
